<script>
	import { link } from 'svelte-routing';
    export let activeClass;
</script>

<aside class="main-sidebar col-12 col-md-3 col-lg-2 px-0">
    <div class="main-navbar">
        <nav
            class="navbar align-items-center navbar-light bg-white p-0 logo-container-height"
        >
            <span class="navbar-brand w-100 mr-0">
                <div class="logo-container" />
            </span>
        </nav>
    </div>

    <div class="nav-wrapper">
        <ul class="nav flex-column">
            <li class="nav-item">
                <a class="nav-link d-flex align-items-center border-none {activeClass == 'books' ? 'active' : ''}"
                    href="/books" use:link>
                    <span class="material-icons">
                        grid_view
                        </span>
                    <span>Books</span>
                </a>
            </li>

          <!--   <li class="nav-item">
                <a
                    class="nav-link border-none {activeClass == 'reviews' ? 'active' : ''}"
                    href="/reviews"
                    ><i class="material-icons">edit</i>
                    <span>Reviews</span></a
                >
            </li> -->
            <!-- <Button on:click={logOutUser}>Logout</Button> -->
        </ul>
    </div>
</aside>

<style type="text/css">

    .main-sidebar {
        border-right: 1px solid #dadddf;
    }

    .nav-link .material-icons {
        margin-right: 15px;
        color: #9b9fa2;
    }

    .main-sidebar .nav .nav-item .nav-link {
        font-size: 14px;
        font-family: 'open_sauce_tworegular';
        color: #9b9fa2;
    }

    .main-sidebar .nav .nav-item .nav-link.active, .main-sidebar .nav .nav-item .nav-link:hover, .main-sidebar .nav .nav-item:hover {
        color: #202428;
        font-family: 'open_sauce_twobold';
    }

    .main-sidebar .nav .nav-item .nav-link.active .material-icons, .main-sidebar .nav .nav-item .nav-link:hover .material-icons, .main-sidebar .nav .nav-item.active .material-icons, .main-sidebar .nav .nav-item:hover .material-icons {
         color: #11bce9;
    }
</style>